import { render } from "./SystemSetup.vue?vue&type=template&id=b7628c36&scoped=true"
import script from "./SystemSetup.vue?vue&type=script&lang=js"
export * from "./SystemSetup.vue?vue&type=script&lang=js"

import "./SystemSetup.vue?vue&type=style&index=0&id=b7628c36&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7628c36"]])

export default __exports__